<template>
    <div class="animated fadeIn">

        <DynamicForm
                v-if="dataSuccess === false"
                ref="dynamicForm"
                getRoot="/purchase-panel"
                saveRoot="/purchase-panel"
                @onRequestSuccess="onRequestSuccess"
                @onSave="onSave"
                :options="{ submit: { text: 'Créer les achats', variant: 'success'} }"
                :formStructure="dataFormStructures.purchase">
            <slot slot="purchases">
                <div class="text-right mb-4">
                    <b-button-group class="btn-group-sm">
                        <b-button @click="addPurchase(Core.Product.typeOrder)" class="btn-light"><i class="fa fa-plus mr-2"></i>{{Core.Definition.getDefinition('Commande')}}</b-button>
                        <b-button @click="addPurchase(Core.Product.typeRecurringSubscription)" class="btn-light"><i class="fa fa-plus mr-2"></i>{{Core.Definition.getDefinition('Abon. récurrent')}}</b-button>
                        <b-button @click="addPurchase(Core.Product.typeLimitedSubscription)" class="btn-light"><i class="fa fa-plus mr-2"></i>{{Core.Definition.getDefinition('Abon. limité')}}</b-button>
                    </b-button-group>
                </div>
                <b-list-group v-if="dataPurchases.length > 0" class="animated slide-fade-enter">
                    <b-list-group-item
                            v-for="purchase, purchaseIndex in dataPurchases"
                            :key="purchaseIndex"
                            :class="{'align-items-start':purchaseIndex===0}"
                            class="cursor-pointer">
                        <b-row>
                            <b-col>
                                <b-btn v-b-toggle="'collapse' + purchaseIndex" class="btn btn-sm btn-light mr-4"><i class="fa fa-chevron-down"></i></b-btn>
                                {{Core.Product.typeLabel(purchase.type)}}
                                <b-btn @click="onTrashClick(purchaseIndex)" class="btn btn-sm btn-danger pull-right"><i class="fa fa-trash-o"></i></b-btn>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-collapse :id="'collapse' + purchaseIndex" class="mt-2">
                                    <hr/>
                                    <FormOrder ref="orderForm" @onUpdateTotal="onUpdateTotal" v-if="purchase.type === Core.Product.typeOrder"></FormOrder>
                                    <FormLimitedSubscription ref="limitedSubscriptionForm" @onUpdateTotal="onUpdateTotal" v-if="purchase.type === Core.Product.typeLimitedSubscription"></FormLimitedSubscription>
                                    <FormRecurringSubscription ref="recurringSubscriptionForm" @onCheckPayment="onCheckPayment" v-if="purchase.type === Core.Product.typeRecurringSubscription"></FormRecurringSubscription>
                                </b-collapse>
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                </b-list-group>
                <b-alert v-else show variant="light">
                    {{Core.Definition.getDefinition('Aucun achat à afficher')}}
                </b-alert>

                <b-row>
                    <b-col></b-col>
                    <b-col lg="4" md="6" sm="12">
                        <table class="table mt-5">
                            <thead>
                                <tr>
                                    <th class="text-right" colspan="2">{{Core.Definition.getDefinition('Sommaire à payer immédiatement')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="text-right">
                                    <b>{{Core.Definition.getDefinition('Sous-total')}}</b>
                                </td>
                                <td class="text-right">
                                    {{Core.Currency.format(dataSubTotal)}}
                                </td>
                            </tr>
                            <tr v-for="tax in dataTaxes">
                                <td class="text-right">
                                    <b>{{tax.label}}</b>
                                </td>
                                <td class="text-right">
                                    {{Core.Currency.format(tax.total)}}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-right">
                                    <b>{{Core.Definition.getDefinition('Total')}}</b>
                                </td>
                                <td class="text-right">
                                    {{Core.Currency.format(dataTotal)}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>

                <ModalPayment
                        ref="modalPayment"
                        v-model="dataPayment"
                        :forceTotal="false"
                        @onTokenizationSuccess="onTokenizationSuccess"
                        @onPaymentCompleted="onPaymentCompleted"></ModalPayment>

            </slot>
            <slot slot="beforeFormButtons">
                <b-button @click="$refs.modalPayment.open = true" class="btn btn-light mr-2">{{Core.Definition.getDefinition('Effectuer un paiement')}}</b-button>
            </slot>
        </DynamicForm>
        <div v-else>
            <b-alert show variant="success">
                {{Core.Definition.getDefinition('Les achats ont été effectuées')}}
            </b-alert>
            <b-btn @click="onResetClick" class="btn btn-success pull-right">{{Core.Definition.getDefinition('Nouvelles achats')}}</b-btn>
        </div>

    </div>
</template>

<script>
    import DynamicForm from '../../components/DynamicForm'
    import FormOrder from '../../components/FormOrder'
    import FormRecurringSubscription from '../../components/FormRecurringSubscription'
    import FormLimitedSubscription from '../../components/FormLimitedSubscription'
    import ModalPayment from '../../components/ModalPayment'
    export default {
        name: 'PurchasePanel',
        components: {
            FormRecurringSubscription,
            FormLimitedSubscription,
            DynamicForm,
            FormOrder,
            ModalPayment
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataPayment: {
                    date: '',
                    method: null,
                    status: null,
                    referenceNumber: '',
                    amount: '0',
                    token : ''
                },
                dataSuccess: false,
                dataTaxes: [],
                dataTotal: 0,
                dataSubTotal: 0,
                dataPurchases: [],
                dataFormStructures: {
                    purchase: {
                        rows: [
                            {
                                cols: [
                                    {
                                        class: 'card-columns',
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Client'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'userAction'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingFirstname'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingLastname'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingEmail'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingPhone'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingAddress'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingCountry'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingProvince'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingCity'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingZipcode'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Notes'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'notes'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                key: 'purchases'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'billingFirstname',
                                type: 'text',
                                label: Core.Definition.getDefinition('Prénom'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'billingLastname',
                                type: 'text',
                                label: Core.Definition.getDefinition('Nom de famille'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'billingEmail',
                                type: 'email',
                                label: Core.Definition.getDefinition('Courriel'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'billingPhone',
                                type: 'phone',
                                label: Core.Definition.getDefinition('Téléphone'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'billingAddress',
                                type: 'text',
                                label: Core.Definition.getDefinition('Adresse'),
                                required: true
                            },
                            {
                                id: 'billingCountry',
                                type: 'country',
                                label: window.Core.Definition.getDefinition('Pays'),
                                required: false,
                                value: {value: 'CA', label :'Canada'},
                                onSelect: function(value, form, fieldRefs) {
                                    if (value !== null && value.value !== undefined) {
                                        fieldRefs['billingProvince'].retrieve(value.value)
                                    } else {
                                        fieldRefs['billingProvince'].dataValue = null
                                    }
                                }
                            },
                            {
                                id: 'billingProvince',
                                type: 'province',
                                value: {value: 'QC', label: 'Quebec'},
                                label: window.Core.Definition.getDefinition('Province'),
                                required: false,
                                onSelect: function() {}
                            },
                            {
                                id: 'billingCity',
                                type: 'text',
                                label: Core.Definition.getDefinition('Ville'),
                                required: true
                            },
                            {
                                id: 'billingZipcode',
                                type: 'text',
                                label: Core.Definition.getDefinition('Code Postal'),
                                required: true
                            },
                            {
                                id: 'notes',
                                type: 'notes'
                            },
                            {
                                id: 'userAction',
                                type: 'userAction',
                                class: 'mb-3 pull-right',
                                updateUser: function(value, form, fieldRefs) {
                                    if (value.firstname === undefined) {
                                        value.firstname = ''
                                    }
                                    fieldRefs['billingFirstname'].dataValue = value.firstname

                                    if (value.lastname === undefined) {
                                        value.lastname = ''
                                    }
                                    fieldRefs['billingLastname'].dataValue = value.lastname

                                    if (value.email === undefined) {
                                        value.email = ''
                                    }
                                    fieldRefs['billingEmail'].dataValue = value.email

                                    if (value.phone === undefined) {
                                        value.phone = ''
                                    }
                                    fieldRefs['billingPhone'].dataValue = value.phone

                                    if (value.billingAddress === undefined) {
                                        value.billingAddress = ''
                                    }
                                    fieldRefs['billingAddress'].dataValue = value.billingAddress

                                    if (value.billingCountry === undefined) {
                                        value.billingCountry = 'CA'
                                    }
                                    fieldRefs['billingCountry'].dataValue = Core.Select.select(value.billingCountry, fieldRefs['billingCountry'].getOptions())

                                    if (value.billingCity === undefined) {
                                        value.billingCity = ''
                                    }
                                    fieldRefs['billingCity'].dataValue = value.billingCity

                                    if (value.billingZipcode === undefined) {
                                        value.billingZipcode = ''
                                    }
                                    fieldRefs['billingZipcode'].dataValue = value.billingZipcode

                                }
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onTrashClick(purchaseIndex) {
                this.dataPurchases.splice(purchaseIndex, 1)
            },
            onTokenizationSuccess(payment) {
                this.$refs.dynamicForm.addSaveArg('payment', JSON.stringify(payment))
                this.$refs.dynamicForm.$refs.form.submit()
            },
            onPaymentCompleted(payment) {
                this.$refs.dynamicForm.addSaveArg('payment', JSON.stringify(payment))
                this.$refs.dynamicForm.$refs.form.submit()
            },
            onResetClick() {
                this.dataPurchases = []
                this.dataSuccess = false
            },
            onCheckPayment(payments) {
                this.evalTotal()
            },
            onUpdateTotal(subTotal, total,  form, fieldRefs) {
                this.evalTotal()
            },
            addPurchase(type) {
                this.dataPurchases.push({
                    type: type
                })
            },
            evalTotal() {
                let subTotal = 0

                let orderForms = this.$refs.orderForm
                let limitedSubscriptionForms = this.$refs.limitedSubscriptionForm
                let recurringSubscriptionForms = this.$refs.recurringSubscriptionForm

                if (orderForms !== undefined) {
                    for(let orderForm in orderForms) {
                        orderForm = orderForms[orderForm]
                        let fieldRefs = orderForm.dataFieldRefs
                        if (fieldRefs['productStandardSummary'] !== undefined) {
                           let products = fieldRefs['productStandardSummary'].dataProducts
                            for(let product in products) {
                                let quantity = products[product].quantity
                                product = products[product].instance
                                subTotal = subTotal + (product.regularPrice * quantity)
                            }
                        }
                    }
                }

                if (limitedSubscriptionForms !== undefined) {
                    for(let limitedSubscriptionForm in limitedSubscriptionForms) {
                        limitedSubscriptionForm = limitedSubscriptionForms[limitedSubscriptionForm]
                        let fieldRefs = limitedSubscriptionForm.dataFieldRefs
                        if (fieldRefs['productLimitedSubscriptionSummary'] !== undefined) {
                            let products = fieldRefs['productLimitedSubscriptionSummary'].dataProducts
                            for(let product in products) {
                                let quantity = products[product].quantity
                                let bookingLimit = products[product].instance.bookingLimit
                                product = products[product].instance
                                subTotal = subTotal + ((product.regularPrice * quantity) / bookingLimit)
                            }
                        }
                    }
                }

                if (recurringSubscriptionForms !== undefined) {
                    for(let recurringSubscriptionForm in recurringSubscriptionForms) {
                        recurringSubscriptionForm = recurringSubscriptionForms[recurringSubscriptionForm]
                        let fieldRefs = recurringSubscriptionForm.dataFieldRefs
                        if (fieldRefs['payments'] !== undefined) {
                            let payments = fieldRefs['payments']
                            payments = fieldRefs['payments'].dataPayments
                            for(let payment in payments) {
                                payment = payments[payment]
                                if (payment.isChecked == true) {
                                    subTotal = subTotal + parseFloat(payment.amount)
                                }
                            }
                        }
                    }
                }

                let taxes = Core.Session.Setting.getTaxes()

                for(let taxIndex in taxes) {
                    let tax = taxes[taxIndex]
                    if (taxes[taxIndex].total !== undefined) {
                        taxes[taxIndex].total = 0
                    }

                    taxes[taxIndex].total = Core.Taxes.total(subTotal, tax)
                }


                let total = subTotal + Core.Taxes.totalTaxes(subTotal, taxes)

                this.dataSubTotal = subTotal
                this.dataTotal = total
                this.dataTaxes = taxes

                this.dataPayment.amount = Core.Currency.currencyFloat(total)
            },
            onSave() {
                let dataOrderForms = []
                let dataLimitedSubscriptionForms = []
                let dataRecurringSubscriptionForms = []

                let orderForms = this.$refs.orderForm
                let limitedSubscriptionForms = this.$refs.limitedSubscriptionForm
                let recurringSubscriptionForms = this.$refs.recurringSubscriptionForm

                if (orderForms !== undefined) {
                    for(let orderForm in orderForms) {
                        orderForm = orderForms[orderForm]
                        let fieldRefs = orderForm.$refs.form.fieldRefs
                        dataOrderForms.push({
                            productStandardSummary: fieldRefs['productStandardSummary'].dataProducts,
                            notes: fieldRefs['notes'].dataValue,
                        })
                    }
                }

                if (limitedSubscriptionForms !== undefined) {
                    for(let limitedSubscriptionForm in limitedSubscriptionForms) {
                        limitedSubscriptionForm = limitedSubscriptionForms[limitedSubscriptionForm]
                        let fieldRefs = limitedSubscriptionForm.$refs.form.fieldRefs
                        dataLimitedSubscriptionForms.push({
                            productLimitedSubscriptionSummary: Core.Value.decode(fieldRefs['productLimitedSubscriptionSummary'].dataProducts, Core.Value.typeProductLimitedSubscriptionSummary),
                            notes: fieldRefs['notes'].dataValue,
                            bookingSummary: fieldRefs['bookingSummary'].dataBookings
                        })
                    }
                }

                if (recurringSubscriptionForms !== undefined) {
                    for(let recurringSubscriptionForm in recurringSubscriptionForms) {
                        recurringSubscriptionForm = recurringSubscriptionForms[recurringSubscriptionForm]
                        let fieldRefs = recurringSubscriptionForm.$refs.form.fieldRefs
                        let payments = []
                        for(let payment in fieldRefs['payments'].dataPayments) {
                            payment = fieldRefs['payments'].dataPayments[payment]

                            if(payment.isChecked !== undefined && payment.isChecked === true) {
                                payment.status = Core.Payment.statusCompleted
                            }

                            payments.push({
                                status: payment.status,
                                method: payment.method,
                                referenceNumber: payment.referenceNumber,
                                amount: payment.amount,
                                date: payment.date
                            })
                        }
                        dataRecurringSubscriptionForms.push({
                            productRecurringSubscriptionSummary: Core.Value.decode(fieldRefs['productRecurringSubscriptionSummary'].dataValue, Core.Value.typeProductRecurringSubscriptionSummary),
                            payments: payments,
                            notes: fieldRefs['notes'].dataValue,
                            bookingSummary: fieldRefs['bookingSummary'].dataValue
                        })
                    }
                }

                this.$refs.dynamicForm.addSaveArg('orderForms', JSON.stringify(dataOrderForms))
                this.$refs.dynamicForm.addSaveArg('limitedSubscriptionForms', JSON.stringify(dataLimitedSubscriptionForms))
                this.$refs.dynamicForm.addSaveArg('recurringSubscriptionForms', JSON.stringify(dataRecurringSubscriptionForms))
            },
            onRequestSuccess(data) {
                if (data.success !== undefined) {
                    this.dataPurchases = []
                    this.dataSuccess = true
                }
            }
        }
    }
</script>
